<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row">
      <div class="col-md-12">
        <pr-input-radio
          formControlName="averageAmountTransactions"
          direction="column"
          [isDefault]="false"
          [options]="options"
          columns="1"
        >
        </pr-input-radio>
      </div>
    </div>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
